import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import Loading from "../Loading";

const SecurePage: React.FC = () => {
  const location = useLocation();
  const { oktaAuth, authState } = useOktaAuth();
  const redirectPath = location.pathname;

  useEffect(() => {
    let refreshTimer: NodeJS.Timeout;

    const setupTokenRefresh = () => {
      if (!authState?.accessToken) return;

      const expiresAt = authState.accessToken.expiresAt;
      if (!expiresAt) return;

      const timeUntilRefresh = expiresAt * 1000 - Date.now() - 5 * 60 * 1000;

      refreshTimer = setTimeout(async () => {
        try {
          await oktaAuth.tokenManager.renew("accessToken");
        } catch (error) {
          console.error("Failed to refresh token:", error);
          await oktaAuth.signInWithRedirect({ originalUri: redirectPath });
        }
      }, timeUntilRefresh);
    };

    setupTokenRefresh();

    return () => {
      if (refreshTimer) clearTimeout(refreshTimer);
    };
  }, [authState?.accessToken, oktaAuth, redirectPath]);

  if (!authState) {
    return <Loading />;
  }

  if (!authState.isAuthenticated) {
    oktaAuth.signInWithRedirect({ originalUri: redirectPath });
    return null;
  }

  return <Outlet />;
};

export default SecurePage;
